export const SUB = '/ui/iam';
export const PREFIX = '';

export const PATH_URL = {
    BASENAME: '/ui/iam',
    DEFAULT_SUB_PATH: '/ui/iam',
    DEFAULT: `${PREFIX}/`,
    LOGIN: `${PREFIX}/login`,
    FORGETLOGIN: `${PREFIX}/forcelogin`,
    PROVIDERS: `${PREFIX}/providers`,
    PAGENOTFOUND: `${PREFIX}/pagenotfound`,
    CHANGEPASSWORD: `${PREFIX}/change-password`,
    INITIAL_LOGIN: '/api/iam/authn/initiate-login',
};
export const HANDLE_ERROR = 'HANDLE_ERROR';
export const ERROR_EXIST = 'ERROR_EXIST';

export const HOME_URL = '/';
export const CHANGE_PASSWORD_URL = 'change-password';
